import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import DocumentCard from '../DocumentCard';
import EmptyState from '../EmptyState';
import {
  Card,
  Header,
  TitleContainer,
  ExpandIcon,
  Title,
  Count,
  Content,
  DocumentsGrid,
} from './DocumentSection.styles';

const DocumentSection = ({ category, isExpanded, onToggle, onDownload }) => {
  const { t } = useTranslation();
  const fileCount = category.files.length;

  return (
    <Card>
      <Header isExpanded={isExpanded} onClick={onToggle}>
        <TitleContainer>
          <ExpandIcon isExpanded={isExpanded} className="mdi mdi-chevron-down" />
          <Title>{category.name}</Title>
          <Count>
            {fileCount} {fileCount === 1 ? t('document') : t('documents')}
          </Count>
        </TitleContainer>
      </Header>

      <Content isExpanded={isExpanded}>
        {fileCount === 0 ? (
          <EmptyState
            icon="mdi-file-document-outline"
            message={t('noDocumentsInSection')}
          />
        ) : (
          <DocumentsGrid>
            {category.files.map((file) => (
              <DocumentCard key={file.id} file={file} onDownload={onDownload} />
            ))}
          </DocumentsGrid>
        )}
      </Content>
    </Card>
  );
};

DocumentSection.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    files: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        originalName: PropTypes.string.isRequired,
      })
    ).isRequired,
  }).isRequired,
  isExpanded: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
  onDownload: PropTypes.func.isRequired,
};

export default DocumentSection;
